import * as types from './types'
import storage from '@/plugins/storage'

export default () => ({
  workOrder: null,
  workOrders: [],
  newWorkOrder: null,
  filteredWorkOrders: [],
  pageSize: parseInt(storage.local.getItem(types.WORKORDER_PAGE_SIZE)) || 10,
  retrospectiveDay: parseInt(storage.local.getItem(types.WORKORDER_DAYS)) || 90,
  searchTerm: storage.session.getItem(types.WORKORDER_SEARCH_TERM) || '',
  status: storage.local.getItem(types.WORKORDER_STATUS) || 'ALL',
  viewDashboard: JSON.parse(storage.local.getItem(types.SET_VIEW_DASHBOARD)),
  viewSection: JSON.parse(storage.local.getItem(types.SET_VIEW_SECTION)),
  filterBy: parseInt(storage.local.getItem(types.WORKORDER_FILTER_BY)) || 0,
  sortDir: storage.session.getItem(types.WORKORDER_SORT_DIR) || 'desc',
  orderBy: storage.session.getItem(types.WORKORDER_ORDER_BY) || 'CreatedDate',
  tools: [],
  devices: [],
  protocols: [],
  interfaces: [],
  statuses: [],
  scanTypes: [],
  dtcs: [],
  odometerUnits: [],
  insurances: [],
  timeZones: [],
  years: [],
  contacts: [],
  reviewScans: [],
  damagePositions: [],
  apiUrl: '',
  businessInfo: [],
  repairLines: null,
  workOrderHistory: null,
  filterOptions: [],
  stateDefaults: null,
  stateAssemblyOptions: [],
  stateSrsOptions: [],
  stateLightOptions: [],
  stateKeyEngineOptions: [],
  stateDamageOptions: [],
  stateDamageLevelOptions: [],
  hubData: null,
  mobileHandoff: null,
  helprequests: null,
  deviceStatisticInterval: 0,
  lineCount: 0,
  isTeamOnly: false,
  isCompletedOnly: false,
  shopDevice: null
})



// WEBPACK FOOTER //
// ./src/store/modules/work-orders/state.js